import { resolveStoryblokStyles, sbEditable, type SBProps, type Spacing } from '../../../utils';

interface SBVerticallySeparatedCardProps {
  counter?: string;
  title?: string;
  content?: string;
  showSeparator?: boolean;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}

export const SBVerticallySeparatedCard = ({ blok }: SBProps<SBVerticallySeparatedCardProps>) => {
  const {
    content,
    counter,
    title,
    showSeparator,
    mbDesktop,
    mbMobile,
    mbTablet,
    mtDesktop,
    mtMobile,
    mtTablet,
  } = blok;

  if (!content && !counter && !title) return null;

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
  });

  return (
    <div className={className} {...sbEditable(blok)}>
      {counter && <p className="text-primary-600 text-lg font-semibold">{counter}</p>}
      {title && <p className="mt-3 text-xl font-semibold text-gray-900 lg:mt-5">{title}</p>}
      {content && <p className="mt-2 text-gray-600">{content}</p>}
      {showSeparator && <hr className="bg-primary-600 mt-4 h-12 w-px border-0" />}
    </div>
  );
};
